module.exports = __webpack_public_path__ + "img/nemlogin-logo.c8b691c8.png";